// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/** Permissions of the client portal (D20, ADR-0028). The seed role client gets read and submit, nothing else. */
export const portalPermissions = definePermissions('portal', {
  read: 'Client users: see in the portal what is shared with their organisation',
  submit: 'Client users: report and answer tickets, and decide on proposals and milestones in the portal',
  manage: 'Give contacts portal access or revoke it, and set what the portal shows per organisation and engagement',
  approve: 'Approve the invitation mail that gives a contact access to the portal',
});
